import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { useEffect,useState } from 'react';
import ConfirmationModal from '../common/ConfirmationModal';
const DepartmentTable = ({ data = [], setDepartments, onEdit, setTableInstance ,onDelete,userType}) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleConfirmDelete = () => {
    if (selectedRow) {
      onDelete(selectedRow.id);
      setConfirmOpen(false);
    }
  };
  const columns = [
    {
      accessorKey: 'name',
      header: 'Department',
      size: 180,
      minSize: 120,
      mantineTableBodyCellProps: {
        style: {
          fontFamily: 'Nunito Sans, sans-serif',
          fontWeight: 600,
          color: '#595C60',
        },
      },
    },
 ...(userType === 'sa'
    ? [{
        accessorKey: 'company_name',
        header: 'Company',
        size: 180,
        minSize: 120,
        mantineTableBodyCellProps: {
          style: {
            fontFamily: 'Nunito Sans, sans-serif',
            fontWeight: 600,
            color: '#595C60',
          },
        },
      }]
    : []),
    {
      accessorKey: 'actions',
      header: 'Actions',
      size: 100,
      minSize: 80,
      Cell: ({ row, table }) => {
        const handleDelete = () => {
          const setDepartments = table.options.meta?.setDepartments;
         setSelectedRow(row.original);
          if (setDepartments && typeof setDepartments === 'function') {
            setConfirmOpen(true);
          } else {
            console.error('setDepartments function is not defined or not a function');
          }
        };

        const handleEdit = () => {
          const onEdit = table.options.meta?.onEdit;
          if (onEdit && typeof onEdit === 'function') {
            onEdit(row.original);
          } else {
            console.error('onEdit function is not defined or not a function');
          }
        };

        return (
          <div className="flex justify-start items-center space-x-3" style={{ backgroundColor: 'transparent' }}>
            <FontAwesomeIcon
              icon={faEdit}
              size="lg"
              className="text-[#FF9F43] cursor-pointer hover:text-[#e68f3b]"
              title="Edit"
              onClick={handleEdit}
            />
            <FontAwesomeIcon
              icon={faTrash}
              size="lg"
              className="text-[#E74C3C] cursor-pointer hover:text-[#c0392b]"
              title="Delete"
              onClick={handleDelete}
            />
          </div>
        );
      },
      mantineTableBodyCellProps: {
        style: {
          height: '48px',
          backgroundColor: 'transparent !important',
        },
      },
    },
  ];

  const table = useMantineReactTable({
    columns,
    data,
    enableRowSelection: true,
    enableStickyHeader: true,
    enableColumnResizing: true,
    enableColumnHiding: true,
    mantineTableContainerProps: {
      style: {
        overflowX: 'auto',
        overflowY: 'auto',
        maxHeight: '400px',
        paddingLeft: '20px',
        paddingRight: '20px',
      },
    },
    mantineTableProps: {
      style: {
        minWidth: 'max-content',
        tableLayout: 'fixed',
        fontFamily: 'Nunito Sans, sans-serif',
        backgroundColor: '#ffffff',
        width: '100%',
      },
      className: 'shadow-sm rounded-lg',
    },
    mantineTableHeadCellProps: {
      style: {
        whiteSpace: 'nowrap',
        backgroundColor: '#F1F4F9',
        borderBottom: '1px solid #e5e7eb',
        padding: '12px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '700',
        fontSize: '14px',
        color: '#202224',
      },
    },
    mantineTableBodyRowProps: {
      style: {
        borderBottom: '0.5px solid #979797',
        backgroundColor: '#ffffff',
        '&:hover': {
          backgroundColor: '#f5f5f5 !important',
        },
      },
    },
    mantineTableBodyCellProps: {
      style: {
        whiteSpace: 'nowrap',
        padding: '12px',
        height: '48px',
        fontFamily: 'Nunito Sans, sans-serif',
        fontWeight: '600',
        color: '#595C60',
        backgroundColor: 'transparent !important',
        '&:hover': {
          backgroundColor: 'transparent !important',
        },
      },
    },
    mantineSelectCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': {
            border: '1px solid #202224 !important',
            backgroundColor: 'transparent !important',
          },
          '&:checked': {
            border: 'none !important',
            backgroundColor: '#FF7A00 !important',
          },
        },
        icon: {
          color: '#ffffff !important',
        },
        wrapper: {
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: 'transparent !important',
        },
      },
      className: 'custom-checkbox-cell',
    },
    mantineSelectAllCheckboxProps: {
      size: 'sm',
      styles: {
        input: {
          '&:not(:checked)': {
            border: '1px solid #202224 !important',
          },
          '&:checked': {
            border: 'none !important',
            backgroundColor: '#FF7A00 !important',
          },
        },
        icon: {
          color: '#ffffff !important',
        },
        wrapper: {
          borderBottom: '1px solid #e5e7eb',
        },
      },
    },
    mantineColumnVisibilityToggleButtonProps: {
      sx: {
        color: '#FF7A00 !important',
        fontFamily: 'Nunito Sans, sans-serif',
        fontSize: '14px',
        border: 'none',
        backgroundColor: 'transparent',
        '&:hover': {
          backgroundColor: '#FFF3E5',
        },
        '& svg': {
          color: '#FF7A00 !important',
        },
      },
    },
    mantineTableToolbarProps: {
      sx: {
        '& .mantine-Menu-item': {
          color: '#FF7A00 !important',
          fontFamily: 'Nunito Sans, sans-serif',
          fontSize: '14px',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#FFF3E5 !important',
          },
        },
        '& .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"], & .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"]': {
          color: '#FF7A00 !important',
          '&:hover': {
            backgroundColor: '#FFF3E5 !important',
          },
        },
      },
    },
    meta: {
      setDepartments,
      onEdit,
    },
  });

  // Pass the table instance to the parent
  useEffect(() => {
    if (setTableInstance) {
      setTableInstance(table);
    }
  }, [table, setTableInstance]);

  return (
    <div className="mb-5">
      <style>
        {`
          .custom-checkbox-cell,
          .custom-checkbox-cell * {
            background-color: transparent !important;
          }
          .custom-checkbox-cell:hover,
          .custom-checkbox-cell *:hover {
            background-color: transparent !important;
          }
          .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"],
          .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"] {
            color: #FF7A00 !important;
            font-family: 'Nunito Sans, sans-serif' !important;
            font-size: 14px !important;
          }
          .mantine-Menu-item[data-testid="mrt-column-visibility-show-all-button"]:hover,
          .mantine-Menu-item[data-testid="mrt-column-visibility-hide-all-button"]:hover {
            background-color: #FFF3E5 !important;
          }
        `}
      </style>
      <MantineReactTable table={table} />
       <ConfirmationModal
        open={confirmOpen}
        onCancel={() => setConfirmOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Delete Department"
        message={`Are you sure you want to delete the department "${selectedRow?.name}"?`}
      />
    </div>
  );
};

export default DepartmentTable;